import { render, staticRenderFns } from "./StockPdf.vue?vue&type=template&id=1c942238&"
import script from "./StockPdf.vue?vue&type=script&lang=js&"
export * from "./StockPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports